import React from 'react';
import { useIntl } from 'react-intl';
import { keyBy } from 'lodash';

import FilterList from './FilterList';
import messages from './messages';

// initial value for appointment status filters
export const STATUS_FILTER_INITIAL_VALUE = ['confirmed', 'unconfirmed'];

// default value for appointment status filters when select all is marked.
// Note: we must send the array of status to make all options will me messaged.
// Reason: if we don't send the specific filters, the backend current flow will not message cancelled appointments.
export const STATUS_FILTER_ALL_SELECTED = ['confirmed', 'unconfirmed', 'cancelled'];

const FilterAppointmentStatus = (props) => {
  const { formatMessage } = useIntl();
  const items = [
    {
      id: 'confirmed',
      name: formatMessage(messages.confirmed),
    },
    {
      id: 'unconfirmed',
      name: formatMessage(messages.unconfirmed),
    },
    {
      id: 'cancelled',
      name: formatMessage(messages.cancelled),
      radioGroup: {
        id: 'cancelled-none',
        items: [
          {
            id: 'cancelled-noshow',
            name: formatMessage(messages.cancelledNoShow),
          },
          {
            id: 'cancelled-none',
            name: formatMessage(messages.cancelledNone),
          },
        ],
      },
    },
  ];

  const allItems = keyBy(items, 'id');

  return <FilterList items={items} allItems={allItems} {...props} />;
};

export default FilterAppointmentStatus;
